// * Bootstrap libraries
import './_bootstrap';
import './style-ddiran.js';

// * Any other global site-wide JavaScript should be placed below.